import { LOCATION_CHANGE } from 'connected-react-router';
import * as actionTypes from '../../types/services';

export const initialState = {
  initServices: false,
  isFetching: false,
  servicesChecked: [],
  serviceTypes: [],
  categories: [],
  providers: [],
  startCounts: [],
  subscriptionTypes: [],
  config: {},
};

const orders = (state = initialState, action) => {
  switch (action.type) {
  // TODO
  case LOCATION_CHANGE: {
    return {
      ...state,
      initServices: state.initServices ? false : state.initServices,
    };
  }
  case actionTypes.INIT: {
    return {
      ...state,
      initServices: false,
    };
  }
  case actionTypes.INIT_SUCCESS: {
    return {
      ...state,
      initServices: true,
    };
  }
  case actionTypes.INIT_ERROR: {
    return {
      ...state,
      initServices: false,
    };
  }
  case actionTypes.SERVICES_SORTABLE_SUCCESS:
  case actionTypes.CATEGORY_SORTABLE_SUCCESS:
  case actionTypes.CATEGORIES_LIST_SUCCESS:
    return {
      ...state,
      categories: action.data,
    };

  case actionTypes.PROVIDERS_LIST_SUCCESS: {
    return {
      ...state,
      providers: action.data,
    };
  }
  case actionTypes.START_COUNTS_LIST_SUCCESS: {
    return {
      ...state,
      startCounts: action.data,
    };
  }
  case actionTypes.SUBSCRIPTION_TYPES_LIST_SUCCESS: {
    return {
      ...state,
      subscriptionTypes: action.data,
    };
  }
  case actionTypes.SERVICE_TYPE_LIST_SUCCESS: {
    return {
      ...state,
      serviceTypes: action.data,
    };
  }
  case actionTypes.CONFIGURATION_SUCCESS: {
    return {
      ...state,
      config: action.data,
    };
  }
  case actionTypes.SERVICE_CHECKED_MASS_ADD: {
    return {
      ...state,
      servicesChecked: action.data,
    };
  }
  case actionTypes.SERVICE_CHECKED_MASS_REMOVE: {
    return {
      ...state,
      servicesChecked: [],
    };
  }
  case actionTypes.SERVICE_CHECKED_SET_STATE: {
    return {
      ...state,
      servicesChecked: action.services,
    };
  }
  case actionTypes.CATEGORY_SERVICES_CHECKED_ADD: {
    const findedCategory = state.categories.find((cat) => cat.id === action.id);
    const categoryServicesIds = findedCategory.services.map((service) => service.id);
    return {
      ...state,
      servicesChecked: [...new Set([...state.servicesChecked, ...categoryServicesIds])],
    };
  }
  case actionTypes.CATEGORY_SERVICES_CHECKED_REMOVE: {
    return {
      ...state,
    };
  }
  case actionTypes.CHANGE_STATUS: {
    return {
      ...state,
      isFetching: true,
    };
  }
  case actionTypes.SERVICE_DELETE: {
    return {
      ...state,
      servicesChecked: state.servicesChecked.filter((id) => id !== action.id),
    };
  }
  case actionTypes.CHANGE_STATUS_ERROR:
  case actionTypes.CHANGE_STATUS_SUCCESS:
    return {
      ...state,
      isFetching: false,
    };
  case actionTypes.SERVICES_MASS_CHANGE_STATUS_SUCCESS:
  case actionTypes.SERVICES_MASS_CHANGE_DRIP_FEED_SUCCESS:
  case actionTypes.SERVICES_MASS_DELETE_SUCCESS:
  case actionTypes.SERVICES_MASS_ASSIGN_CATEGORY:
  case actionTypes.SERVICES_MASS_RESET_CUSTOM_RATES:
    return {
      ...state,
      servicesChecked: [],
    };
  default: {
    break;
  }
  }

  return state;
};

export default orders;
